import { getModalityColor, getModalityTagImage } from "@modules/personalRecords/personalRecord.utils"
import { FavoritesPersonalRecord } from "@modules/profile/publicProfile/publicProfileTypes"
import { HUText } from "@modules/ui/components/huText"
import { HURow } from "@modules/ui/components/layout"
import { useGetDisplayedScore } from "@modules/utils/hooks/useUnit"
import styled, { useTheme } from "styled-components"

type HUFavoritePersonalRecordMiniCardsProps = {
  item: FavoritesPersonalRecord
} & React.HTMLAttributes<HTMLDivElement>

export const HUFavoritePersonalRecordMiniCards: React.FC<HUFavoritePersonalRecordMiniCardsProps> = ({
  item,
  ...props
}) => {
  const theme = useTheme()
  const getScore = useGetDisplayedScore()

  return (
    <div {...props}>
      <PersonalRecordContainer $color={getModalityColor(item.movement.modality, theme)}>
        {getModalityTagImage(item.movement.modality, 30)}
        <HURow style={{ alignItems: "baseline" }} gap={2}>
          <HUText fontStyle="TM">{getScore(item.personalRecord.value || 0, item.movement.scoreType)}</HUText>
        </HURow>
        <HUText fontStyle="BS">{item.movement.movementName}</HUText>
      </PersonalRecordContainer>
    </div>
  )
}

const PersonalRecordContainer = styled.div<{ $color: string }>`
  width: 133px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 3px;
  border-radius: 20px;
  border: 1px solid ${({ $color }) => $color};
`
